import { createStyles } from "@mantine/core";
import { ThemeMode } from "../../../../Enums/themeMode";

export const useStyles = createStyles((theme) => ({
  table: {
    marginBottom: "3rem",
  },
  tableHeader: {
    backgroundColor:
      theme.colorScheme === ThemeMode.DARK
        ? theme.colors.dark[4]
        : theme.colors.gray[3],
  },
  headText: {
    color:
      theme.colorScheme === ThemeMode.DARK
        ? theme.colors.dark[1]
        : theme.colors.light[1],
  },
  requestBoxContainer: {
    border: "solid 1px",
    borderColor: "#FFDB5C",
    width: 56,
    borderRadius: 10,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 3,
    paddingBottom: 3,
    backgroundColor: "#FFFEF1",
  },
  quantityText: {
    marginLeft: 5,
  },
  actionsContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    alignSelf: "center",
    justifyContent: "center",
  },
  iconTrashContainer: {
    backgroundColor: "#E63324",
    borderRadius: 50,
    marginRight: 10,
    alignSelf: "center",
    alignItems: "center",
  },
  iconActionContainer: {
    backgroundColor: "#27A536",
    borderRadius: 50,
    marginRight: 10,
    alignSelf: "center",
    alignItems: "center",
  },
  emptyResultsMessage: {
    textAlign: "center",
    marginTop: "1rem",
    position: "absolute",
    color:
      theme.colorScheme === ThemeMode.DARK
        ? theme.colors.gray[1]
        : theme.colors.light[1],
    width: "100%",
  },
  bodyContainer: {
    justifyContent: "center",
  },
  tableText: {
    color:
      theme.colorScheme === ThemeMode.DARK
        ? theme.colors.gray[1]
        : theme.colors.light[1],
  },
  actionLink: {
    alignItems: "center",
    cursor: "pointer",
    justifyContent: "left",
    color:
      theme.colorScheme === ThemeMode.DARK
        ? theme.colors.dark[1]
        : theme.colors.light[1],
    "&:hover": {
      background: "transparent",
    },
  },
}));
